import * as bootstrap from 'bootstrap'
import * as _ from 'lodash-es'
import bootbox from 'bootbox'
import * as base64url from '../helpers/base64url'


const meta = 'profile'
window[`fnc_${meta}`] = initProfilePage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

function initProfilePage() {
    $('.iso-date').each(function() {
        const t = $(this).text() !== '' ? new Date($(this).text()).toLocaleDateString(globals.vars.locales)+ ', ' +new Date($(this).text()).toLocaleTimeString(globals.vars.locales) : 'N/A'
        $(this).text(t)
    })

    $('.delete-key').off().on('click', function(e) {
        e.preventDefault()

        const externalId =  $(this).attr('data-key')

        bootbox.confirm({
            title: global.i18n.t('dialogs.confirmation'),
            message: global.i18n.t('dialogs.generic_action'),
            centerVertical: true,
            buttons: {
                confirm: {
                label:  global.i18n.t('buttons.yes'),
                className: 'btn-danger'
                },
                cancel: {
                    label: global.i18n.t('buttons.no'),
                    className: 'btn-light'
                }
            },
            callback: function (result) {
                if (!result)
                    return

                const params = {
                    externalId: externalId,
                    _csrf: $("meta[name=_csrf]").attr("content")
                }

                $.ajax({
                    url: '/json/delete-passkey',
                    method: 'POST',
                    data: params,
                    success: function (response) {
                        if (typeof response['error'] !== 'undefined') {
                            helpers.alert(response)
                        }
                        if (DEBUG) console.log(response)
            
                        window.location.reload()
                    },
                    error: function (err) {
                        helpers.alert(err)
                    }
                })
            }
        })
    })

    $('#profile-form').on('submit', function (event) {
        event.preventDefault()
        event.stopPropagation()

        const params = { }

        $('#profile-form :input').each(function() {
            if (typeof $(this).attr('id') !== 'undefined')
                params[ $(this).attr('id') ] = $(this).val()
        })

        const invalid = $('#profile-form :invalid')

        if (invalid.length > 0)
            return

        helpers.updateProfile(params, true)
    })        
}

